import { nodeUtils } from './nodeUtils';

export const extractNamesFromRecipe = (recipe) => {
  if (Object.keys(recipe).length === 0) {
    return new Map();
  }

  const nodeData = new Map();

  // Extract names and types from connectors
  recipe.connectors?.connector?.forEach((connector) => {
    if (connector?.['@id']) {
      const name = nodeUtils.getNodeName(connector.name);
      const type = connector.type?.['#text'] || connector.type;
      nodeData.set(connector['@id'], { name, type });
    }
  });

  // Extract names and types from statements
  recipe.statements?.statement?.forEach((statement) => {
    if (statement?.['@id']) {
      const type = statement.action || statement.type?.['#text'] || statement.type;
      let name;

      if (nodeUtils.getNodeType(statement) === 'dataframe') {
        name = nodeUtils.getNodeName(statement['data-frame']);
      } else {
        name = nodeUtils.getNodeName(statement.name);
      }

      nodeData.set(statement['@id'], { name, type });
    }
  });

  // Extract names and types from tasks
  recipe.tasks?.task?.forEach((task) => {
    if (task?.['@id']) {
      const name = nodeUtils.getNodeName(task.name);
      const type = task.type?.['#text'] || task.type;
      nodeData.set(task['@id'], { name, type });
    }
  });

  // Extract names and types from read formats
  recipe.readFormats?.readFormat?.forEach((format) => {
    if (format?.['@id']) {
      const name = nodeUtils.getNodeName(format.name);
      const type = format.type?.['#text'] || format.type;
      nodeData.set(format['@id'], { name, type });
    }
  });

  // Extract names and types from write formats
  recipe.writeFormats?.writeFormat?.forEach((format) => {
    if (format?.['@id']) {
      const name = nodeUtils.getNodeName(format.name);
      const type = format.type?.['#text'] || format.type;
      nodeData.set(format['@id'], { name, type });
    }
  });

  // Extract names and types from imports
  recipe.imports?.import?.forEach((importItem) => {
    if (importItem?.['@id']) {
      const name = nodeUtils.getNodeName(importItem.name);
      const type = importItem.type?.['#text'] || importItem.type;
      nodeData.set(importItem['@id'], { name, type });
    }
  });

  return nodeData;
};
